import { useMemo } from "react";

import type { useGetEarningsUsTherapist } from "api/hooks/useGetEarningsUsTherapist";
import { convertCentsToDollars } from "utils/convertCentsToDollars";

import type { EarningsChartData } from "./types";

export const useEarningsChartData = (data: ReturnType<typeof useGetEarningsUsTherapist>["data"]) => {
  return useMemo(() => {
    if (!data) return undefined;

    const earningsArray = Object.entries(data.earnings).map(([start_date, categories]) => {
      const totals = Object.entries(categories).reduce((acc, [category, details]) => {
        acc[category] = convertCentsToDollars(details.total);
        acc[`${category}_total_billed`] = convertCentsToDollars(details.total_billed);
        return acc;
      }, {} as Record<string, string>);

      return {
        start_date,
        ...totals,
      } as EarningsChartData;
    });

    return earningsArray.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
  }, [data]);
};
